<template>
  <div class="charge">
    <div>
      <div v-if="reportingId" class="go-back" @click="goBack">>>返回</div>
      <div v-if="!reportingId" class="searchbox">
        <form action="#" method="get" class="form-inline form-float">
          <div class="form-group">
            <label for>道路:</label>
            <search-parking></search-parking>
          </div>
          <div class="form-group">
            <label for>类型</label>
            <el-select
              style="width: 150px"
              v-model="search.fbType"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="item in allFbType"
                :key="item.value"
                :label="item.labelZhCh"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>

          <div class="form-group" style="margin-left: 40px">
            <label for>内容</label>
            <input
              v-model="search.fbMsg"
              class="form-control"
              id
              type="text"
              placeholder
              size="12"
              v-noBlankSpace
            />
          </div>

          <div class="form-group">
            <label for="bdate">时间</label>
            <el-date-picker
              clearable
              value-format="yyyy-MM-dd HH:mm:ss"
              :editable="false"
              v-model="search.startTime"
              type="datetime"
              placeholder="选择日期时间"
            ></el-date-picker>
          </div>
          <div class="form-group">
            <label for="edate">至</label>
            <el-date-picker
              clearable
              value-format="yyyy-MM-dd HH:mm:ss"
              :editable="false"
              v-model="search.endTime"
              type="datetime"
              placeholder="选择日期时间"
            ></el-date-picker>
          </div>
          <div class="form-group others">
            <span class="search_btn">
              <button
                @click="searchList"
                type="button"
                class="btn btn-primary"
                id="search_btn"
              >
                查询
              </button>
            </span>

            <!--<button @click="clearSearch" type="button" class="btn btn-default">清空</button>-->
            <!-- <span class='refresh_btn'><Refresh @tableList="this.tableList"></Refresh></span> -->
          </div>
          <div class="form-group others">
            <button
              @click="downloadData"
              type="button"
              class="btn btn-primary"
              id="search_btn"
            >
              导出
            </button>
          </div>
        </form>
      </div>
      <div class="list">
        <el-table
          ref="table"
          border
          :data="tableListData"
          height="100%"
          :header-cell-style="tableHeaderStyle"
          :cell-style="styleObj"
        >
          <el-table-column
            show-overflow-tooltip
            label="停车道路"
            prop="parkingName"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="反馈人"
            prop="name"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="反馈时间"
            prop="fbDate"
          ></el-table-column>
          <el-table-column show-overflow-tooltip label="信息类型" prop="fbType">
            <!-- <template slot-scope="scope">{{scope.row.fbType=='exit_error'?'无车报有车':'有车报无车'}}</template> -->
          </el-table-column>
          <el-table-column show-overflow-tooltip label="车位号" prop="spaceNum">
            <!-- <template slot-scope="scope">{{
              JSON.parse(scope.row.spaceId).spaceNum
            }}</template> -->
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="内容"
            prop="fbMsg"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="状态"
            prop="proceStatus"
          ></el-table-column>
          <el-table-column show-overflow-tooltip label="操作" width="200px">
            <template slot-scope="scope">
              <button
                class="margin-right edit"
                title="查看"
                href="javascript:;"
                @click="photo(scope.row.id)"
              >
                <span>查看</span>
              </button>
              <button
                class="edit"
                title
                href="javascript:;"
                @click="deal(scope.row.id, scope.row.proceStatus)"
                :style="{
                  color:
                    scope.row.proceStatus === '进行中'
                      ? '#278CD8 !important'
                      : 'gray !important',
                }"
              >
                <span>处理</span>
              </button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <Page v-if="!reportingId" v-on:pagination="receivePaginationData"></Page>
    <!-- 照片 -->
    <check-photo
      :dialogFormVisiblePhoto="dialogFormVisiblePhoto"
      :pics="allImgUrl"
      v-on:func="setDialogStatus"
    />

    <!-- 处理 -->
    <el-dialog
      title="处理"
      :close-on-click-modal="false"
      :lock-scroll="false"
      :visible.sync="dialogFormVisible"
      width="430px"
    >
      <el-form
        ref="form"
        label-position="right"
        :model="form"
        :rules="rules"
        :label-width="formLabelWidth"
        id="form"
      >
        <el-form-item label="状态">
          <el-select v-model="form.status" placeholder="请选择">
            <el-option
              v-for="item in allDealStatus"
              :key="item.index"
              :label="item.labelZhCh"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="dealTrue()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";

import {
  dictValue,
  getHandsetList,
  getHandsetSingle,
  dealHandset,
  getHandsetByReportingId
} from "@/api/url";

import Page from "../../commons/page";
import AreaTree from "../../commons/areaTree";
import CheckPhoto from "../../commons/checkPhoto";
import SearchParking from "@/page/commons/searchParking";

export default {
  data() {
    return {
      handset_btn_deal: false,
      moduleName: "",
      treeData: {
        parkingId: "",
      },
      styleObj: {
        "text-align": "center",
      },

      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      allFbType: [],
      search: {
        pageNumber: 1,
        pageSize: 10,
        fbMsg: "",
        fbType: "",
        startTime: "",
        endTime: "",
      },
      tableListData: [],

      formLabelWidth: "100px",
      dialogFormVisible: false,
      allDealStatus: [
        {
          value: "complete",
          labelZhCh: "完成",
        },
        {
          value: "cancel",
          labelZhCh: "取消",
        },
      ],
      form: {
        id: "",
        status: "complete",
      },
      rules: {},

      dialogFormVisiblePhoto: false,
      allImgUrl: [],
      imgUrl: "",
      reportingId:""
    };
  },

  components: {
    Page,
    // Refresh,
    AreaTree,
    CheckPhoto,
    SearchParking,
  },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
      parking: (state) => state.parking.oneParking,
    }),
    ...mapGetters(["elements"]),
    permiss() {
      this.handset_btn_deal = this.elements["handset:btn_deal"];
    },
  },
  created: function() {
    this.permiss;
    this.getFbType();
    this.reportingId=this.$route.query.reportingId;
   
  },
  mounted: function() {
    if(this.reportingId){
      this.reqHandsetByReportingId();
      return;
    }
    this.tableList(this.search.pageNumber);
  },
  watch: {
    elements: {
      handler: function(val, oldVal) {
        this.permiss;
      },
      deep: true,
    },
  },
  methods: {
    ...mapMutations(["getPage"]),

    getFbType: function() {
      this.$get(dictValue() + "/feedback_type").then((data) => {
        this.allFbType = data.data.rows;
      });
    },
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      this.tableList(this.search.pageNumber);
    },
    tableList: function(curPage, open) {
      var _this = this;
      const { fbMsg, fbType, pageSize, startTime, endTime } = this.search;
      this.$get(getHandsetList(), {
        fbMsg: fbMsg ? fbMsg : null,
        fbType: fbType ? fbType : null,
        parkingId: this.parking?.parkingId ?? null,
        limit: pageSize ? pageSize : 10,
        page: curPage,
        beginTime: startTime ? startTime : null,
        endTime: endTime ? endTime : null,
      }).then((data) => {
        if (data?.status != 200) return;
        //翻页
        var pageObj = {
          curIndex: data.data.offset,
          rowsCount: data.data.total,
        };
        _this.getPage(pageObj);
        const {
          data: { rows },
        } = data;
        _this.tableListData = (rows ?? []).map((item) => {
          if (
            item.parkingId &&
            typeof JSON.parse(item.parkingId) === "object"
          ) {
            item.parkingName = JSON.parse(item.parkingId).parkingName;
          }
          if (item.hmid && typeof JSON.parse(item.hmid) === "object") {
            item.name = JSON.parse(item.hmid).name;
          }
          item.spaceNum = JSON.parse(item?.spaceId ?? "{}")?.spaceNum ?? "";
          return item;
        });
      });
    },
    searchList: function() {
      var flTime = this.timeCompare(this.search.startTime, this.search.endTime);
      // console.log(this.search.endTime)
      if (flTime) {
        return this.$layer.msg("开始时间请勿大于结束时间", { time: 1 });
      } else if (
        !Boolean(this.search.startTime) &&
        Boolean(this.search.endTime)
      ) {
        return this.$layer.msg("请选择开始时间", { time: 1 });
      } else if (
        Boolean(this.search.startTime) &&
        !Boolean(this.search.endTime)
      ) {
        return this.$layer.msg("请选择结束时间", { time: 1 });
      }
      this.search.pageNumber = "1";
      this.tableList(this.search.pageNumber);
    },
    timeCompare: function(bDateVal, eDateVal) {
      // console.log(bDateVal,eDateVal);

      if (!Boolean(bDateVal) || !Boolean(eDateVal)) {
        return false;
      }

      var bdate = new Date(Date.parse(bDateVal.replace(/-/g, "/")));
      bdate = bdate.getTime();
      var edate = new Date(Date.parse(eDateVal.replace(/-/g, "/")));
      edate = edate.getTime();
      if (bdate - edate > 0) {
        return true;
      } else {
        return false;
      }
    },
    clearSearch: function() {
      this.search.pageNumber = "1";
      this.search.fbMsg = "";
      this.search.fbType = "";
      this.search.startTime = "";
      this.search.endTime = "";
    },
    photo: function(id) {
      this.dialogFormVisiblePhoto = true;
      this.allImgUrl = [];
      this.$postRequest(getHandsetSingle(), {
        id,
      }).then((data) => {
        if (data.status != 200) return;
        const {
          data: { imageHead, imageTail, imageSideways },
        } = data;
        if (imageHead) {
          this.allImgUrl.push(imageHead);
        }
        if (imageTail) {
          this.allImgUrl.push(imageTail);
        }
        if (imageSideways) {
          this.allImgUrl.push(imageSideways);
        }
        // this.allImgUrl = [
        //   data.data.imageHead,
        //   data.data.imageTail,
        //   data.data.imageSideways,
        // ];
      });
    },
    setDialogStatus() {
      this.dialogFormVisiblePhoto = false;
    },
    deal: function(id, status) {
      if (status !== "进行中") {
        return;
      }
      this.dialogFormVisible = true;
      this.form.id = id;
    },
    dealTrue: function() {
      var _this = this;
      this.$refs["form"].validate(function(valid, noStri) {
        if (valid) {
          _this.dialogFormVisible = false;

          _this
            .$postRequest(dealHandset(), {
              id: _this.form.id,
              proceStatus: _this.form.status,
            })
            .then((data) => {
              if (data.status != 200) return;
              var result = data.data;
              _this.tableList(_this.curIndex);
            });
        }
      });
    },
    downloadData() {
      const { fbMsg, fbType, pageSize, startTime, endTime } = this.search;
      this.$downloadFileRequest(
        "/api/parking/abnormalFeedback/abnormalFeedbackExport",
        {
          fbMsg: fbMsg ? fbMsg : null,
          fbType: fbType ? fbType : null,
          parkingId: this.parking?.parkingId ?? null,
          beginTime: startTime ? startTime : null,
          endTime: endTime ? endTime : null,
        },
        "巡检员信息反馈"
      );
    },
    goBack(){
     this.$router.go(-1)
    },
    reqHandsetByReportingId(){
      this.$get(`${getHandsetByReportingId()}/${this.reportingId}`).then(data=>{
        if(data?.status!==200) return;
        this.tableListData=[data?.data??{}]
      })
    }
  },
};
</script>

<style scoped>
.modal-body .tab-img li {
  width: 100px;
  height: 100px;
  margin: 10px 10px;
}
.modal-body .tab-img {
  display: flex;
  justify-content: center;
}
.go-back{
  padding:20px 0 0 20px;
  box-sizing: border-box;
  cursor: pointer;
}
</style>
